'use strict';

const filterTokens = (theme) => ({
    filterTextColor: theme.colors.primary.normal,
    filterFontFamily: theme.typography.fontFamily.regular,
    filterFontSize: theme.typography.fontSize.m,
});

exports.filterTokens = filterTokens;
//# sourceMappingURL=filter.js.map
